<template>
  <div class="sku-price">
    <div class="sku-price-type" v-if="sku.activity && sku.activity.discount">
      <i>{{sku.activity.discount===sku.market_price?'售价':'优惠价'}}</i>:
      <span>
        ¥
        <em>{{ sku.activity.discount }}</em>
      </span>
      <del class="market-price" v-if='sku.activity.discount!==sku.market_price'>¥{{ sku.market_price }}</del>
    </div>
    <div class="sku-price-type" v-else-if="sku.equity && sku.equity.discount">
      <i>{{sku.equity.discount===sku.market_price?'售价':'优惠价'}}</i>:
      <span>
        ¥
        <em>{{ sku.equity.discount }}</em>
      </span>
      <del class="market-price" v-if='sku.equity.discount!==sku.market_price'>¥{{ sku.market_price }}</del>
    </div>
    <div class="sku-price-type" v-else-if="sku.market_price">
      <div class="normal-price">
        市场价:
        <span>
          ¥
          <em>{{ sku.market_price }}</em>
        </span>
      </div>
    </div>
    <a v-if='contrast' :href='url' class="contrast">一键比价</a>
  </div>
</template>

<script>
export default {
  name: 'productPrice',
  components: {
  },
  props: {
    sku: {
      type: Object
    },
    contrast: {
      type: Boolean
    },
    url: {
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.sku-price{
  display: flex;
  align-items: center;
}
.contrast{
  border:0.01rem solid #FF3824;
  border-radius:0.1rem;
  padding:0.02rem 0.05rem;
  color:#FF3824;
}
.sku-price-type {
  color: @price;
  font-size: @fz22;
  padding: 0.16rem 0;
  white-space: nowrap;
  span {
    font-size: 0.18rem;
    padding-left: 0.05rem;
    padding-right: 0.16rem;
  }
  em {
    font-size: @fz28;
    font-weight: bold;
  }
  .market-price {
    font-size: @fz22;
    color: @base;
    padding-right: 0.16rem;
  }
}
</style>
